/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Resource_Form_No_Of_Units_HintInputs */

const en_admin_resource_form_no_of_units_hint = /** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How many of this resource do you have?`)
};

const de_admin_resource_form_no_of_units_hint = /** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viele Personen diese Ressource gleichzeitig buchen können`)
};

const es_admin_resource_form_no_of_units_hint = /** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuántas personas pueden reservarlo al mismo tiempo`)
};

const fr_admin_resource_form_no_of_units_hint = /** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Combien d'unités avez-vous de cette ressource ?`)
};

const nl_admin_resource_form_no_of_units_hint = /** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoeveel van deze voorziening heb je?`)
};

/** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */
const it_admin_resource_form_no_of_units_hint = en_admin_resource_form_no_of_units_hint;

/** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */
const pt_br2_admin_resource_form_no_of_units_hint = en_admin_resource_form_no_of_units_hint;

/** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */
const pl_admin_resource_form_no_of_units_hint = en_admin_resource_form_no_of_units_hint;

/** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */
const hu_admin_resource_form_no_of_units_hint = en_admin_resource_form_no_of_units_hint;

/** @type {(inputs: Admin_Resource_Form_No_Of_Units_HintInputs) => LocalizedString} */
const ro_admin_resource_form_no_of_units_hint = en_admin_resource_form_no_of_units_hint;

/**
* | output |
* | --- |
* | "How many of this resource do you have?" |
*
* @param {Admin_Resource_Form_No_Of_Units_HintInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_resource_form_no_of_units_hint = /** @type {((inputs?: Admin_Resource_Form_No_Of_Units_HintInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Resource_Form_No_Of_Units_HintInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "de") return de_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "es") return es_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "fr") return fr_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "nl") return nl_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "it") return it_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "pt-BR") return pt_br2_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "pl") return pl_admin_resource_form_no_of_units_hint(inputs)
	if (locale === "hu") return hu_admin_resource_form_no_of_units_hint(inputs)
	return ro_admin_resource_form_no_of_units_hint(inputs)
});
export { admin_resource_form_no_of_units_hint as "admin.resource_form.no_of_units_hint" }